import { FC, useEffect, useState } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { useHistory } from "react-router-dom";
import { currency } from "functions/redux/general/action";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "functions/redux/store";
import { getPrivateTripAuthor } from "functions/redux/listing/homeAction";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useTranslation } from "react-i18next";
import NcModal from "shared/NcModal/NcModal";
import { getGuidePrivateTrip, updateStateTrip } from "functions/redux/listing/action";
import NcDropDown from "shared/NcDropDown/NcDropDown";
import { toast } from "react-toastify";

export interface GuidePrivateTripCardProps {
    className?: string;
    ratioClass?: string;
    data?: IProduct | null;
    user?: any;
    size?: "default" | "small";
}

const GuidePrivateTripCard: FC<GuidePrivateTripCardProps> = ({
    size = "default",
    className = "",
    data = null,
    user,
    ratioClass,
}) => {

    const dispatch = useDispatch();
    const { listing } = useSelector((state: RootStore) => state);
    const history = useHistory();
    const [confimationModal, setConfirmationModal] = useState(false);
    const [tripId, settripId] = useState(0);
    const [tripState, settripState] = useState('');
    const [tripName, settripName] = useState('');
    const { t } = useTranslation();
    useEffect(() => {
        if (data != null && user == null && (listing.privateTripAuthor == null || (listing.privateTripAuthor != null && listing.privateTripAuthor[data.id] == null))) {
            dispatch(getPrivateTripAuthor(data));
        }
    })

    const updateStatus = async(id:any, state:any) => {
        let form = {
            'id':id,
            'state':state
        }
        
        let update = await updateStateTrip(form);
        
        dispatch(getGuidePrivateTrip());
        setConfirmationModal(false);
        
        if (update.code === 200) {
            toast('Trips '+state)
        }else{

        }
    }

    const renderSliderGallery = (gal: any) => {
        return (
            <div className="relative w-full">
                <GallerySlider ratioClass={ratioClass} galleryImgs={gal} />
                {/* <Link to={`/private-trip-add${data?.country ? `?id=${data.country[0].id}` : ''}`}
                    className="!absolute -mt-8 right-0 mr-4 bg-primary-6000 text-white rounded-md h-auto w-auto  p-2 items-center justify-center"
                >
                    <i className="las la-edit"></i>
                </Link> */}
            </div>
        );
    };

    const renderContent = (data: IProduct) => {
        let guideDetail: any;
        let profile: any;
        if (user) {
            guideDetail = user?.credential?.guideDetail;
            profile = user?.credential?.profile;
        } else {
            guideDetail = listing.privateTripAuthor ? listing.privateTripAuthor[data.id].guideDetail[0] : null;
            profile = listing.privateTripAuthor ? listing.privateTripAuthor[data.id].profile[0] : null;
        }
        let dat = [
            {id:'1',name:'Edit',icon:'las la-edit'},
            {id:'2',name:data.state === 'archived' ? 'Publish' : 'Archive',icon:data.state === 'archived' ? 'las la-upload' : 'las la-archive' },
            {id:'3',name:'Delete',icon:'las la-trash'},
        ];
        if (data.state === 'draft') {
            dat = [
                {id:'1',name:'Edit',icon:'las la-edit'},
                {id:'2',name:'Delete',icon:'las la-trash'},
            ];
        }
        return (

            <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
                <NcModal
                    isOpenProp={confimationModal}
                    renderTrigger={() => { return (<div></div>); }}
                    hideCloseBtn={true}
                    // contentExtraClass="w-1/4"
                    modalTitle={t('confirmation')}
                    renderContent={() => {
                        return (
                            <div className="max-w-md">
                                <span className="text-center font-regular">
                                {tripState === 'deleted' ? "Open "+t("confirm_update_delete",{name:tripName, state:tripState}) : "Open "+t("confirm_update_archive",{name:tripName, state:tripState})}
                                </span>
                                {tripState === 'deleted' && (
                                    <div style={{justifyContent:'center'}}>
                                        <span className="text-center font-light">{t("confirm_update_delete_desc")}</span>
                                    </div>
                                )}
                                <br/>
                                <div className="flex flex-row w-full mt-8 space-x-4">
                                    <ButtonSecondary onClick={() => setConfirmationModal(false)} className="flex-1 p-2 h-min">No</ButtonSecondary>
                                    <ButtonPrimary  onClick={() => {
                                        updateStatus(tripId, tripState)
                                    }} className="flex-1 w-full h-min p-2 ">
                                        Yes
                                    </ButtonPrimary>
                                </div>
                            </div>
                        );
                    }}
                    
                />

                <div style={{display:'flex', justifyContent:'space-between'}}>
                <span className={`nc-Badge inline-flex px-2.5 py-1 rounded-full font-medium text-xs w-auto ml-2 ${data.state === "draft" ? "text-blue-800 bg-blue-100" : data.state === "published" ?  "text-pink-800 bg-pink-100" : "text-purple-800 bg-purple-100"}  w-auto ml-2`} style={{borderRadius:10, padding:5, fontSize: 12}}>{data.state}</span>

                    {/* <Link to={`/private-trip-add${data?.country ? `?id=${data.country[0].id}` : ''}`}
                        className="bg-primary-6000 text-white flex justify-center items-center"
                        style={{borderRadius:50, paddingRight:8, paddingLeft:8}}
                    >
                        <i className="las la-edit"></i>
                    </Link> */}
                    <NcDropDown data={dat} onClick={(item) => {
                       if (item.id === '1') {
                            history.push(`/private-trip-add${data?.country ? `?id=${data.country[0].id}` : ''}`)
                       }else{
                            settripId(data.id);
                            settripName(data.title);
                            if (item.id === '2') {
                                if (data.state === 'draft') {
                                    settripState('deleted');
                                }else if (data.state === 'archived') {
                                    settripState('published');
                                } else{
                                    settripState('archived');
                                }
                            } else {
                                    settripState('deleted');
                            }
                           setConfirmationModal(true);
                       }
                    }}/>
                </div>
                <div className="space-y-2">
                    {/* <Badge name={`Private trip`} className="w-auto mb-2" color="pink" /> */}

                    <div className="flex flex-row items-center space-x-4 ">
                        <Avatar sizeClass="w-20 h-20" imgUrl={profile?.avatar} />
                        <div>
                            <h2
                                className={`font-semibold capitalize font-medium text-lg `}
                            >
                                <span className="">{guideDetail?.agencyName}</span>
                            </h2>
                            <div>
                                <span className="text-neutral-500 dark:text-neutral-400 text-sm  ">{data?.country ? (data?.country[0]).name : ''}</span>
                                {
                                    data?.productLocation &&
                                    <Badge name={`${data?.productLocation.length} recommendations`} className="w-auto ml-2 " color="green" />
                                }

                            </div>

                        </div>
                    </div>
                    <div className=" flex-col mt-6 space-y-2">

                        <span className=" text-neutral-500 dark:text-neutral-400 text-sm ">{data?.highlight ?? "Add highlight"}</span><br />
                        <span className=" text-neutral-600 dark:text-neutral-500 text-sm ">{data?.description ?? "Add highlight"}</span><br />
                    </div>
                    <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
                        <span className="">{data?.maxGuest ?? 0} Guest included</span>

                    </div>
                    {data?.additionalContact ?
                        <span className="text-neutral-500 dark:text-neutral-400 text-sm space-x-2">Additional contact : {data?.additionalContact}</span>
                        : <></>}
                </div>
                <div className=" border-b border-neutral-100 dark:border-neutral-800"></div>
                <div className="flex justify-between items-center">
                    <span className="text-base font-semibold">
                        {currency(data?.totalPrice ? parseInt(data.totalPrice.toString()) : 0)}
                        <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                            / pax
                        </span>
                    </span>

                </div>
               
            </div>
        );
    };

    return (

        <div
            className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow ${className}`}
            data-nc-id="StayCard"
        >
            {data != null ?
                <div>
                    {renderSliderGallery(data.file)}
                    {renderContent(data)}
                </div>
                : <></>}
        </div >
    );
};

export default GuidePrivateTripCard;
